export const redirectToDocumentation = (docsRedirectUrl) => {
  if (docsRedirectUrl) {
    window.location.replace(docsRedirectUrl)
  }
}